import { Component } from '@angular/core';

import { DatahubService } from '../../../services/datahub.service';

@Component({
  selector: 'app-modal-content-about-timesheet',
  templateUrl: './modal-content-about-timesheet.component.html',
  standalone: false,
})
export class ModalContentAboutTimesheetComponent {
  weekending: string;
  constructor(public datahub: DatahubService) {
    this.weekending = this.datahub.date.getHumanReadableDateString(this.datahub.date.getWeDate());
  }
}
